import type { CalculatorAnketaType } from '@pomoshnik/shared';

/**
 * Per-anketa Header title (sticky header экрана AnketaForm / FreeAnketaForm).
 *
 * Prototype refs (verified verbatim):
 * - kitchen → «Кухня» (2.12.2:337, fontSize 36px Bebas Neue)
 * - cabinet → «Шкаф» (2.12.3:304, fontSize 40px)
 * - bath-tabletop → «Сан Узел: тумба со столешницей» (2.12.4:305, fontSize 26px)
 * - bath-shelf-above → «Сан Узел: шкаф над антресолью» (2.12.5:284, fontSize 26px)
 * - bath-cabinet → «Сан Узел: Шкаф» (2.12.6:295, fontSize 30px)
 * - tv-zone → «ТВ-зона в гостиную» (2.12.7:332, fontSize 30px)
 * - balcony → «Шкаф на балкон» (2.12.8:313, fontSize 32px)
 * - other → «Другая мебель» (2.12.9:97, fontSize 40px)
 *
 * **NB:** существует другой mapping `CALCULATOR_ANKETA_TYPE_LABELS` в
 * `packages/shared/src/domain/calculator-anketa-types-vocabulary.ts` для
 * CalculatorEntry picker context (составные labels: «Шкаф / Гардероб»,
 * «Санузел: Тумба...»). Унификация — B-105 (BACKLOG).
 */
export const ANKETA_TYPE_LABELS: Record<CalculatorAnketaType, string> = {
  kitchen: 'Кухня',
  cabinet: 'Шкаф',
  'bath-tabletop': 'Сан Узел: тумба со столешницей',
  'bath-shelf-above': 'Сан Узел: шкаф над антресолью',
  'bath-cabinet': 'Сан Узел: Шкаф',
  'tv-zone': 'ТВ-зона в гостиную',
  balcony: 'Шкаф на балкон',
  other: 'Другая мебель',
};

/**
 * Per-anketa heading для SectionParams (Section А).
 *
 * Прототип:
 * - kitchen → «Параметры кухни» (2.12.2:352)
 * - все остальные → «Параметры изделия» (2.12.3:319, 2.12.4:319, 2.12.5:298,
 *   2.12.6:309, 2.12.7:344, 2.12.8:325, 2.12.9:111 — аналогично)
 */
export const SECTION_PARAMS_HEADER: Record<CalculatorAnketaType, string> = {
  kitchen: 'Параметры кухни',
  cabinet: 'Параметры изделия',
  'bath-tabletop': 'Параметры изделия',
  'bath-shelf-above': 'Параметры изделия',
  'bath-cabinet': 'Параметры изделия',
  'tv-zone': 'Параметры изделия',
  balcony: 'Параметры изделия',
  other: 'Параметры изделия',
};

/**
 * Per-anketa heading для SectionAdditional (Section В).
 *
 * Прототип:
 * - cabinet → «Особые конструкции» (2.12.3:460)
 * - все остальные → «Дополнительные элементы» (2.12.2:450 и аналогично)
 *
 * Note: Cabinet special structure refactor (facade-radius перенос в Section Г
 * Наполнение, Витрина в отдельной секции) — это PR-Hotfix-2B scope. В 2A
 * только label override.
 */
export const SECTION_ADDITIONAL_HEADER: Record<CalculatorAnketaType, string> = {
  kitchen: 'Дополнительные элементы',
  cabinet: 'Особые конструкции',
  'bath-tabletop': 'Дополнительные элементы',
  'bath-shelf-above': 'Дополнительные элементы',
  'bath-cabinet': 'Дополнительные элементы',
  'tv-zone': 'Дополнительные элементы',
  balcony: 'Дополнительные элементы',
  other: 'Дополнительные элементы',
};
